<template src="./template.html"></template>

<script>
export default {
  name: "ImageDialog",
  props: {
    images: {
      require: true,
      type: Array
    }
  },
  data() {
    return {
      dialog: false,
      active_index: 0
    }
  },
  methods: {
    SetActive(index) {
      this.active_index = index
    },
    Open(index) {
      this.dialog = true
      this.active_index = index
    },
    Prev() {
      this.active_index == 0 ? this.active_index = this.images.length - 1 : this.active_index -= 1
    },
    Next() {
      this.active_index == this.images.length - 1 ? this.active_index = 0 : this.active_index += 1
    }
  }
}
</script>